import type { MarketOutcome } from '@/stores/game'
import {
  BALL_COLOR_STYLES,
  getColorOutcomeSlug,
  parseColorFromOutcomeSlug,
  type BallColorSlug,
} from '@/constants/sameColorBalls'

export const STANDARD_BET_PLUS_COLOR_BONUS_SLUG = 'standard-bet-excl-bonus-plus-color-bonus'

export function isStandardBetPlusColorBonusMarket(slug: string): boolean {
  return slug === STANDARD_BET_PLUS_COLOR_BONUS_SLUG
}

export function formatColorBonusBallLabel(color: BallColorSlug): string {
  const label = BALL_COLOR_STYLES[color].label
  const titleCase = label.charAt(0) + label.slice(1).toLowerCase()
  return `${titleCase} Bonus ball`
}

export function getColorComboLineBonusLabel(line: {
  bonusColor?: BallColorSlug | null
  market?: { label?: string; market?: { slug?: string } } | null
}): string | null {
  if (line.bonusColor) {
    return formatColorBonusBallLabel(line.bonusColor)
  }
  if (isStandardBetPlusColorBonusMarket(line.market?.market?.slug ?? '') && line.market?.label) {
    const parts = line.market.label.split('+')
    if (parts.length >= 2) {
      const colorPart = parts[parts.length - 1].trim().replace(/\s+bonus$/i, '').trim()
      if (colorPart) {
        const titleCase = colorPart.charAt(0) + colorPart.slice(1).toLowerCase()
        return `${titleCase} Bonus ball`
      }
    }
  }
  return null
}

export function resolveColorBonusOutcome(
  outcomes: MarketOutcome[],
  color: BallColorSlug,
  mainPickCount: number,
  gameMarketId?: number | null
): MarketOutcome | undefined {
  if (gameMarketId) {
    const byId = outcomes.find((o) => o.game_market_id === gameMarketId)
    if (byId) {
      return byId
    }
  }

  const slug = getColorOutcomeSlug(color)
  return outcomes.find(
    (o) => o.slug.toLowerCase() === slug && Number(o.pick) === mainPickCount
  )
}

export function formatStandardBetPlusColorBonusLabel(
  mainNumbers: number[],
  outcome: MarketOutcome
): string {
  const color = parseColorFromOutcomeSlug(outcome.slug)
  const colorLabel = color ? BALL_COLOR_STYLES[color].label : outcome.text.toUpperCase()
  const nums = [...mainNumbers].sort((a, b) => a - b).join(', ')
  return `${nums} + ${colorLabel} bonus`
}

export function buildStandardBetPlusColorBonusSelection(
  mainNumbers: number[],
  outcome: MarketOutcome
) {
  return {
    odds: Number(outcome.odds),
    outcome_id: outcome.id.toString(),
    game_market_id: outcome.game_market_id ?? undefined,
    picks: mainNumbers.length,
    label: formatStandardBetPlusColorBonusLabel(mainNumbers, outcome),
  }
}
